export default __webpack_public_path__ + "static/vertical-gain-753679b3b07db3bb6803d48c9d9fbead.svg";